import { useNavigate } from "react-router-dom";

const Service: React.FC = () => {
    const navigate = useNavigate();

    function bookOneMonth(): void {
        window.open('https://calendly.com/aghvida-info/lifestyle-coaching-path', '_blank', 'noopener,noreferrer');
    }

    function bookThreeMonths(): void {
        window.open('https://calendly.com/aghvida-info/lifestyle-prescription-path-one-month-clone', '_blank', 'noopener,noreferrer');
    }

    function bookSixMonths(): void {
        window.open('https://calendly.com/aghvida-info/lifestyle-prescription-path-three-months-clone', '_blank', 'noopener,noreferrer');
    }

    function openBookLifestylePrescriptionPath(): void {
        window.open('https://calendly.com/aghvida-info/lifestyle-prescription-path', '_blank', 'noopener,noreferrer');
    }

    function openBookInformationSession(): void {
        window.open('https://calendly.com/aghvida-info/informational-session', '_blank', 'noopener,noreferrer');
    }

    function openLetsTalk(): void {
        navigate('/letstalk')
    }

    function openBookPersonalizedCareContent(): void {
        window.open('https://calendly.com/aghvida-info/introductory-session-personalized-care-content', '_blank', 'noopener,noreferrer');
    }

    function openBookComplementaryIntroduction(): void {
        window.open('https://calendly.com/aghvida-info/complementary-introduction', '_blank', 'noopener,noreferrer');
    }

    return (
        <>
            <section data-background="white">
                <group data-direction="column">
                    <space data-height="90"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper>
                            <group className="article">
                                <group data-length="forcefit" data-fit="1" data-max-length="500" data-justify="center"
                                    data-adaptive="desktop">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="500">
                                        <img src="./images/S11.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-max-length="500" data-justify="center"
                                    data-adaptive="mobile">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="400">
                                        <img src="./images/S11.2.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-wrap="no">
                                    <space data-length="100" data-adaptive="desktop"></space>
                                    <group data-margin="auto" data-direction="column" data-gap="50"
                                        data-max-length="700" data-justify="center">
                                        <text className="title" data-wrap="wrap" data-weight="700" data-type="group"
                                            data-direction="column">
                                            <text data-wrap="wrap" data-text-size="xxx-large">Complementary
                                                Introduction</text>
                                        </text>
                                        <group className="" data-wrap="no" data-radius="10" data-justify="center"
                                            data-gap="20" data-max-length="500" data-length="forcefit">
                                            <group data-opacity="30" data-width="auto" data-align="start"> <text
                                                    data-type="group" data-text-size="64" data-line-height="50"
                                                    data-height="20">“</text></group>
                                            <group data-direction="column" data-gap="10">

                                                <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                    data-line="2" data-text-align="justify" data-color="black">
                                                    Assist me in clarifying my inquiries and gaining a deeper
                                                    understanding of the service that most effectively aligns with my
                                                    well-being needs.
                                                </text>
                                            </group>
                                            <group data-opacity="30" data-width="auto" data-align="end"> <text
                                                    data-rotate="180" data-type="group" data-text-size="64"
                                                    data-line-height="50" data-height="20">“</text></group>
                                        </group>
                                        <group>
                                            <text data-wrap="wrap" data-line="2" data-weight="700" data-text-align="justify">
                                                Many of us are not clear about the direction that we need to take to keep healthy.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                
                                                In this one time free 20-minute discovery call, we’ll cut through the confusion 
                                                and agree on a health direction that actually fits your life goals. Whether you 
                                                have questions about Lifestyle Medicine or need help navigating a broken health 
                                                system, you’ll leave this session with expert answers and a clear 
                                                recommendation on which of our services will help you thrive. 
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-space-horizontal="5">No guesswork, just a plan.</text>
                                            </text>
                                        </group>
                                        
                                        <group className="section_toolbar">
                                            <div className="button primary large" data-min-length="200" onClick={openBookComplementaryIntroduction}><text>Book
                                                    Now</text></div>
                                        </group>
                                    </group>
                                </group>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    <space data-height="90"></space>
                </group>
            </section>

            <section>
                <group data-direction="column">
                    <space data-height="90"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper>
                            <group className="article">
                                <group data-length="forcefit" data-fit="1" data-justify="center" data-adaptive="mobile">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="400">
                                        <img src="./images/S12.2.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-wrap="no" data-justify="">
                                    <group data-margin="auto" data-direction="column" data-gap="50"
                                        data-max-length="700" data-justify="center">
                                        <text className="title" data-wrap="wrap" data-weight="700" data-type="group"
                                            data-direction="column">
                                            <text data-wrap="wrap" data-text-size="xxx-large">Lifestyle
                                                Prescription Path</text>
                                        </text>
                                        <group className="" data-wrap="no" data-radius="10" data-justify="center"
                                            data-gap="20" data-max-length="500" data-length="forcefit">
                                            <group data-opacity="30" data-width="auto" data-align="start"> <text
                                                    data-type="group" data-text-size="64" data-line-height="50"
                                                    data-height="20">“</text></group>
                                            <group data-direction="column" data-gap="10">

                                                <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                    data-line="2" data-text-align="justify" data-color="black">
                                                    Provide me with a well-structured lifestyle change prescription that
                                                    I can independently implement to achieve and sustain desired
                                                    outcomes
                                                </text>
                                            </group>
                                            <group data-opacity="30" data-width="auto" data-align="end"> <text
                                                    data-rotate="180" data-type="group" data-text-size="64"
                                                    data-line-height="50" data-height="20">“</text></group>
                                        </group>
                                        <group>
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                Lasting health isn’t about luck—it’s about having a science-backed roadmap that actually fits your life.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                In this two 60-minutes sessions, we’ll do a deep-dive into your health risks, goals, and daily habits across the
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-space-horizontal="5"> Six Pillars of Lifestyle Medicine.</text>
                                            </text>
                                        </group>
                                        <group data-direction="column" data-gap="5" data-space-left="20">
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-name="mark">Your Lifestyle Prescription:&nbsp;</text>
                                                A custom, practical plan designed to stick, even on your busiest days.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-name="mark">The Resilience Toolkit:&nbsp;</text>
                                                Expert resources and 'troubleshooting' tips to keep you on track when life gets in the way.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2">
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-name="mark">Relapse Prevention:&nbsp;</text>
                                                Proven strategies to ensure your new healthy habits become your new normal.
                                            </text>
                                        </group>
                                        <text className="description" data-wrap="wrap" data-line="2">
                                            This is your chance to gain the tools to take full charge of your well-being, both now and for the years to come.
                                        </text>
                                        <group className="section_toolbar" data-justify="end">
                                            <div className="button secondary large" data-min-length="200" onClick={openBookLifestylePrescriptionPath}>
                                                <text>Book Now</text>
                                            </div>
                                        </group>
                                    </group>
                                    <space data-length="100" data-adaptive="desktop"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-justify="center" data-adaptive="desktop"
                                    data-max-length="500">
                                    <picture data-object-fit="contain" data-ratio="1:1">
                                        <img src="./images/S12.png" alt="" />
                                    </picture>
                                </group>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    <space data-height="90"></space>
                </group>
            </section>


            <section data-background="white">
                <group data-direction="column">
                    <space data-height="90"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper>
                            <group className="article">
                                <group data-length="forcefit" data-fit="1" data-max-length="500" data-justify="center"
                                    data-adaptive="desktop">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="500">
                                        <img src="./images/S13.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-max-length="500" data-justify="center"
                                    data-adaptive="mobile">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="400">
                                        <img src="./images/S13.2.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-wrap="no">
                                    <space data-length="100" data-adaptive="desktop"></space>
                                    <group data-margin="auto" data-direction="column" data-gap="50"
                                        data-max-length="700" data-justify="center">
                                        <text className="title" data-wrap="wrap" data-weight="700" data-type="group"
                                            data-direction="column">
                                            <text data-wrap="wrap" data-text-size="xxx-large">Lifestyle
                                                Coaching Path</text>
                                        </text>
                                        <group className="" data-wrap="no" data-radius="10" data-justify="center"
                                            data-gap="20" data-max-length="500" data-length="forcefit">
                                            <group data-opacity="30" data-width="auto" data-align="start"> <text
                                                    data-type="group" data-text-size="64" data-line-height="50"
                                                    data-height="20">“</text></group>
                                            <group data-direction="column" data-gap="10">

                                                <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                    data-line="2" data-text-align="justify" data-color="black">
                                                    Provide me with a well-structured lifestyle change prescription that
                                                    you can walk me step-by-step to implement and sustain desired
                                                    outcomes
                                                </text>
                                            </group>
                                            <group data-opacity="30" data-width="auto" data-align="end"> <text
                                                    data-rotate="180" data-type="group" data-text-size="64"
                                                    data-line-height="50" data-height="20">“</text></group>
                                        </group>
                                        <group>
                                            <text className="description" data-wrap="wrap" data-line="2" data-text-align="justify">
                                                If you’re looking for more than just a plan—if you want an expert who truly cares 
                                                and walks beside you until your goals become your reality—this is for you. We start with a 
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-space-horizontal="5">Deep-Dive Health Discovery</text>
                                                (two 60-minute sessions) to map out your unique risks and opportunities across the 
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-space-horizontal="5">Six Pillars of Lifestyle Medicine.</text>
                                                We don't just give you advice; we craft a 'Lifestyle Prescription' that fits into the life you actually lead.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2" data-weight="700">
                                                How we stay by your side:
                                            </text>
                                        </group>
                                        <group data-direction="column" data-gap="5" data-space-left="20">
                                            <text className="description" data-wrap="wrap" data-line="2" data-text-align="justify">
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-name="mark">Calibration Calls:&nbsp;</text>
                                                Weekly up to two 20-min check-ins to celebrate wins, tackle hurdles and fine-tune your habits in real-time like a precision instrument.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2" data-text-align="justify">
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-name="mark">Constant Support:&nbsp;</text>
                                                Direct text access for those 'in-the-moment' questions when you need an expert most.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2" data-text-align="justify">
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-name="mark">Weekly Progress Reports:&nbsp;</text>
                                                Clear, data-driven insights that show you exactly how far you’ve come.
                                            </text>
                                            <text className="description" data-wrap="wrap" data-line="2" data-text-align="justify">
                                                <text data-wrap="wrap" data-line="2" data-weight="700" data-name="mark">Your Graduation Kit:&nbsp;</text>
                                                At the end of your 1, 3, or 6-month path, you receive a full 'Success Report' with custom relapse-prevention tips and a library of resources to keep you thriving.
                                            </text>
                                        </group>
                                        <text className="description" data-wrap="wrap" data-line="2" data-text-align="justify">Let's build the best version of your health, together.</text>
                                        <group className="section_toolbar" data-gap="10">
                                            <div className="button primary large" data-min-length="180" onClick={bookOneMonth}>
                                                <text>Book One Month</text>
                                            </div>
                                            <div className="button primary large" data-min-length="180" onClick={bookThreeMonths}>
                                                <text>Book Three Months</text>
                                            </div>
                                            <div className="button primary large" data-min-length="180" onClick={bookSixMonths}>
                                                <text>Book Six Months</text>
                                            </div>
                                        </group>
                                    </group>
                                </group>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    <space data-height="90"></space>
                </group>
            </section>


            <section>
                <group data-direction="column">
                    <space data-height="90"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper>
                            <group className="article">
                                <group data-length="forcefit" data-fit="1" data-justify="center" data-adaptive="mobile">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="400">
                                        <img src="./images/S14.2.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-wrap="no" data-justify="">
                                    <group data-margin="auto" data-direction="column" data-gap="50"
                                        data-max-length="700" data-justify="center">
                                        <text className="title" data-wrap="wrap" data-weight="700" data-type="group"
                                            data-direction="column">
                                            <text data-wrap="wrap"
                                                data-text-size="xxx-large">Informational Session</text>
                                        </text>
                                        <group className="" data-wrap="no" data-radius="10" data-justify="center"
                                            data-gap="20" data-max-length="500" data-length="forcefit">
                                            <group data-opacity="30" data-width="auto" data-align="start"> <text
                                                    data-type="group" data-text-size="64" data-line-height="50"
                                                    data-height="20">“</text></group>
                                            <group data-direction="column" data-gap="10">

                                                <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                    data-line="2" data-text-align="justify" data-color="black">
                                                    Provide a detailed answer to my question around my health
                                                </text>
                                            </group>
                                            <group data-opacity="30" data-width="auto" data-align="end"> <text
                                                    data-rotate="180" data-type="group" data-text-size="64"
                                                    data-line-height="50" data-height="20">“</text></group>
                                        </group>
                                        <text className="description" data-wrap="wrap" data-line="2" data-text-align="justify">
                                            Navigating the medical world alone is exhausting. In this 60-minute session, we’ll sit down to discuss your health concerns in a pressure-free environment. A brief 
                                            <text data-wrap="wrap" data-line="2" data-weight="700">&nbsp;Lifestyle Medicine 6 Pillars Assessment&nbsp;</text>
                                            will be done to help frame our conversation. I’ll help you decode what’s happening, answer your inquiries, provide science-backed insights and if needed, point you toward the exact external services you need—so you never have to guess about your health again.
                                        </text>

                                        <group className="section_toolbar" data-justify="end">
                                            <div className="button secondary large" data-min-length="200" onClick={openBookInformationSession}><text>Book
                                                    Now</text></div>
                                        </group>
                                    </group>
                                    <space data-length="100" data-adaptive="desktop"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-justify="center" data-adaptive="desktop"
                                    data-max-length="500">
                                    <picture data-object-fit="contain" data-ratio="1:1">
                                        <img src="./images/S14.png" alt="" />
                                    </picture>
                                </group>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    <space data-height="90"></space>
                </group>
            </section>

            <section data-background="white">
                <group data-direction="column">
                    <space data-height="90"></space>
                    <group data-wrap="no">
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                        <wrapper>
                            <group className="article">
                                <group data-length="forcefit" data-fit="1" data-max-length="500" data-justify="center"
                                    data-adaptive="desktop">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="500">
                                        <img src="./images/S15.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-max-length="500" data-justify="center"
                                    data-adaptive="mobile">
                                    <picture data-object-fit="contain" data-ratio="1:1" data-max-length="400">
                                        <img src="./images/S15.2.png" alt="" />
                                    </picture>
                                    <space data-height="50" data-adaptive="mobile"></space>
                                </group>
                                <group data-length="forcefit" data-fit="1" data-wrap="no">
                                    <space data-length="100" data-adaptive="desktop"></space>
                                    <group data-length="forcefit" data-fit="1" data-wrap="no" data-justify="">
                                    <group data-margin="auto" data-direction="column" data-gap="50"
                                        data-max-length="700" data-justify="center">
                                        <text className="title" data-wrap="wrap" data-weight="700" data-type="group"
                                            data-direction="column">
                                            <text data-wrap="wrap" data-text-size="xxx-large">Personalized Care
                                                Content</text>
                                        </text>
                                        <group className="" data-wrap="no" data-radius="10" data-justify="center"
                                            data-gap="20" data-max-length="500" data-length="forcefit">
                                            <group data-opacity="30" data-width="auto" data-align="start"> <text
                                                    data-type="group" data-text-size="64" data-line-height="50"
                                                    data-height="20">“</text></group>
                                            <group data-direction="column" data-gap="10">

                                                <text className="list_description" data-wrap="wrap" data-text-size="14"
                                                    data-line="2" data-text-align="justify" data-color="black">
                                                    Send me customized content that informs and motivates me to thrive in alignment with my health goals
                                                </text>
                                            </group>
                                            <group data-opacity="30" data-width="auto" data-align="end"> <text
                                                    data-rotate="180" data-type="group" data-text-size="64"
                                                    data-line-height="50" data-height="20">“</text></group>
                                        </group>
                                        <group data-gap="20">
                                            <text className="description" data-wrap="wrap" data-line="2" data-text-align="justify">
                                                Want personalized health and lifestyle coaching without the live meetings? Our monthly personalized care content is designed for the busy individual who prefers to stay 'offline' but still wants an expert in their corner. After a complementary 20-minute intro call where we map out your unique health needs, I’ll send you a hand-crafted, monthly guide to thrive and maintain balanced health specifically around the six domains of Lifestyle Medicine. Each letter is packed with
                                                <text data-wrap="wrap" data-line="2" data-weight="700">&nbsp;science-backed tips, personalized resources, and actionable wisdom&nbsp;</text>
                                                tailored specifically to your goals. It’s like having a lifestyle doctor as a pen pal.
                                            </text>
                                        </group>

                                        <group className="section_toolbar">
                                            <div className="button primary large" data-min-length="200" onClick={openBookPersonalizedCareContent}>
                                                <text>Book Now</text>
                                            </div>
                                        </group>
                                    </group>
                                    <space data-length="100" data-adaptive="desktop"></space>
                                </group>
                                </group>
                            </group>
                        </wrapper>
                        <space data-length="50" data-adaptive="desktop"></space>
                        <space data-length="30" data-adaptive="mobile"></space>
                    </group>
                    <space data-height="90"></space>
                </group>
            </section>
        </>
    );
};

export default Service;